<template>
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line stroke="currentColor" x1="10.9629" y1="1.1973" x2="0.356327" y2="11.8039" />
        <line stroke="currentColor" x1="10.9589" y1="11.8047" x2="0.352346" y2="1.19812" />
    </svg>
</template>
